import { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "../assets/ts_signage_logo.svg";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useNavigate } from "react-router-dom";

const AppHeader = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");

  useEffect(() => {
    const updateUsername = () => {
      const storedUsername = JSON.parse(localStorage.getItem("userData"));
      setUsername(
        (storedUsername &&
          `${storedUsername.first_name} ${storedUsername.last_name}`) ||
          "User"
      );
    };

    updateUsername(); // initial load

    window.addEventListener("userDataUpdated", updateUsername);

    return () => {
      window.removeEventListener("userDataUpdated", updateUsername);
    };
  }, []);

  const logout = () => {
    navigate("/logout");
  };
  return (
    <Navbar expand="lg">
      <Container fluid className="px-3">
        <Navbar.Brand className="m-0 px-2">
          <Image src={logo} alt="Digital Signage" height={50} width={150}/>
        </Navbar.Brand>
        <Nav className="me-auto">
          {/* <Nav.Link href="#features">Features</Nav.Link>
            <Nav.Link href="#pricing">Pricing</Nav.Link> */}
        </Nav>
        <Nav>
          <NavDropdown title={username} align="end">
            <NavDropdown.Item
              href="#"
              className="small text-black"
              onClick={() => navigate(`/my-profile`)}
            >
              My Profile
            </NavDropdown.Item>
            <NavDropdown.Item onClick={logout} className="small text-black">
              Logout
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default AppHeader;
